<template>
  <div class="info-center-container">
    <MCard :title="$t('操作日志')" title-align="center">
      <div style="padding: 20px; box-sizing: border-box; height: 100%">
        <Search :formModel="formModel" :formButton="formButton" />
        <MTable
          i18n-path="query"
          :loading="loading"
          :tableData="hisData"
          :tableColumn="tableColumn"
          :pagiOption="pagiOption"
          height="calc(100% - 120px)"
          v-on:search="search"
        />
      </div>
    </MCard>
  </div>
</template>

<script>
import { formatTime } from '@/utils/date';
import { dayTime, convertArrayToObject } from '@/utils/utils';
// import { merge } from 'lodash';
import Search from '@/components/mTable/search';
import MCard from '@/components/mCard/index.vue';

import MTable from '@/components/mTable/m-table';
import { logInfoServer } from '@/api/air-monitor/information-center';
import { dictByCodeServer } from '@/api/dict';

export default {
  computed: {
    comParams() {
      const { formModel, pagiOption } = this;
      return {
        beginTime: formModel.rangeDateVal && formModel.rangeDateVal[0],
        endTime: formModel.rangeDateVal && formModel.rangeDateVal[1],
        limit: pagiOption.limit,
        offset: pagiOption.offset
      };
    }
  },
  data() {
    return {
      loading: true,
      hisData: [],
      formModel: {
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      formButton: [
        {
          text: '查询',
          event: () => {
            this.pagiOption.offset = 1;
            this.search();
          }
        }
      ],
      tableColumn: [
        { label: '标题', prop: 'title' },
        { label: '事件类型', prop: 'eventTypeShow' },
        { label: '事件状态', prop: 'statuShow' },
        { label: '内容', prop: 'content' },
        { label: '处理人', prop: 'createName' },
        {
          label: '时间',
          prop: 'createDate',
          temp: scope => {
            return `<span>${formatTime(scope.row.createDate)}</span>`;
          }
        }
      ],
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30, 100, 200],
        layout: 'total, sizes, prev, pager, next, jumper'
      }
    };
  },
  async mounted() {
    this.statusDict = {
      0: '未上报',
      1: '已上报',
      2: '待处置',
      3: '已处置'
    };
    this.loadDictOptions();
    await this.search();
  },
  methods: {
    loadDictOptions() {
      let eventOptions = [];

      dictByCodeServer('rf122_event_type').then(res => {
        res.data.forEach(item => {
          eventOptions.push({
            value: item.value,
            label: item.label
          });
        });
        this.eventDict = convertArrayToObject(res.data);
      });
    },
    search() {
      logInfoServer(this.comParams)
        .then(res => {
          if (res.code == 200) {
            res.data.list.forEach(item => {
              item.statuShow = this.$t(this.statusDict[item.status]) || this.$t('无');

              item.eventTypeShow = item.eventType
                ? this.eventDict[item.eventType] || this.$t('无')
                : this.$t('无');
            });
            this.pagiOption.total = res.data.total;
            this.hisData = res.data.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  components: { MCard, Search, MTable }
};
</script>

<style lang="scss" scoped>
.info-center-container {
  box-sizing: border-box;

  height: 100%;

  .m-table {
    height: calc(100% - 80px);
  }
}
</style>
